// Scroll-hide sticky header
(function(){
  var header = document.getElementById('kjHeader');
  if(!header) return;
  var lastY = window.scrollY;
  window.addEventListener('scroll', function(){
    var y = window.scrollY;
    if (y > lastY && y > 120) header.classList.add('hide');
    else header.classList.remove('hide');
    lastY = y;
  }, { passive:true });
})();

// Product page: Add to Cart (AJAX, stays on page) + Buy Now (adds then redirects to checkout)
(function(){
  var addBtn = document.getElementById('kjAddToCart');
  var buyBtn = document.getElementById('kjBuyNow');
  var variantSelect = document.getElementById('kjVariantId');
  var qtyInput = document.getElementById('kjQty');
  var msg = document.getElementById('kjCartMsg');

  if (!addBtn) return;

  function addToCart(){
    var id = variantSelect.value;
    var quantity = parseInt(qtyInput.value, 10) || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity }] })
    }).then(function(res){
      if (!res.ok) return res.json().then(function(err){ throw err; });
      return res.json();
    });
  }

  function updateCartCount(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var countEl = document.querySelector('.kj-cart-count');
      var cartIcon = document.querySelector('a[href*="/cart"].kj-icon-btn');
      if (countEl) {
        countEl.textContent = cart.item_count;
      } else if (cartIcon && cart.item_count > 0) {
        var span = document.createElement('span');
        span.className = 'kj-cart-count';
        span.textContent = cart.item_count;
        cartIcon.appendChild(span);
      }
    });
  }

  addBtn.addEventListener('click', function(){
    addBtn.disabled = true;
    var originalText = addBtn.textContent;
    addBtn.textContent = 'Adding...';
    addToCart().then(function(){
      updateCartCount();
      msg.textContent = 'Added to cart! You can continue shopping or view your cart.';
      addBtn.textContent = originalText;
      addBtn.disabled = false;
    }).catch(function(err){
      msg.textContent = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
      addBtn.textContent = originalText;
      addBtn.disabled = false;
    });
  });

  if (buyBtn) {
    buyBtn.addEventListener('click', function(){
      buyBtn.disabled = true;
      buyBtn.textContent = 'Redirecting...';
      addToCart().then(function(){
        window.location.href = '/checkout';
      }).catch(function(err){
        msg.textContent = (err && err.description) ? err.description : 'Could not proceed. Please try again.';
        buyBtn.textContent = 'Buy Now';
        buyBtn.disabled = false;
      });
    });
  }
})();

// Product option swatch selection -> updates hidden variant select
(function(){
  document.querySelectorAll('.kj-option-values').forEach(function(group){
    var swatches = group.querySelectorAll('.kj-swatch');
    swatches.forEach(function(s, i){
      if (i === 0) s.classList.add('selected');
      s.addEventListener('click', function(){
        swatches.forEach(function(x){ x.classList.remove('selected'); });
        s.classList.add('selected');
      });
    });
  });
})();

// Cart page: quantity +/-, remove item, live subtotal via /cart/change.js
(function(){
  var itemsWrap = document.getElementById('kjCartItems');
  if (!itemsWrap) return; // not on cart page

  var wrap = document.getElementById('kjCartWrap');
  var emptyEl = document.getElementById('kjCartEmpty');
  var subtotalEl = document.getElementById('kjCartSubtotal');
  var checkoutBtn = document.getElementById('kjCheckoutBtn');
  var msg = document.getElementById('kjCartMsg');

  function money(cents, format){
    var value = (cents / 100).toFixed(2);
    return (format || '').replace(/\{\{\s*amount\s*\}\}/, value) || ('Rs. ' + value);
  }

  function setBusy(row, busy){
    if (busy) row.style.opacity = '0.5'; else row.style.opacity = '1';
    row.querySelectorAll('button').forEach(function(b){ b.disabled = busy; });
  }

  function syncHeaderCount(count){
    var countEl = document.querySelector('.kj-cart-count');
    var cartIcon = document.querySelector('a[href*="/cart"].kj-icon-btn');
    if (countEl) {
      countEl.textContent = count;
      if (count === 0) countEl.remove();
    } else if (cartIcon && count > 0) {
      var span = document.createElement('span');
      span.className = 'kj-cart-count';
      span.textContent = count;
      cartIcon.appendChild(span);
    }
  }

  function changeLine(key, quantity, row){
    setBusy(row, true);
    msg.textContent = '';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res){ return res.json(); })
    .then(function(cart){
      if (quantity === 0) {
        row.remove();
      } else {
        var line = cart.items.filter(function(i){ return i.key === key; })[0];
        if (line) {
          row.querySelector('.kj-qty-val').textContent = line.quantity;
          row.querySelector('.kj-cart-line-price').textContent = window.Shopify && window.Shopify.formatMoney
            ? window.Shopify.formatMoney(line.final_line_price)
            : 'Rs. ' + (line.final_line_price / 100).toLocaleString('en-PK');
        }
        setBusy(row, false);
      }

      subtotalEl.textContent = window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(cart.total_price)
        : 'Rs. ' + (cart.total_price / 100).toLocaleString('en-PK');

      syncHeaderCount(cart.item_count);

      if (cart.item_count === 0) {
        wrap.style.display = 'none';
        emptyEl.style.display = 'block';
      }
    })
    .catch(function(){
      msg.textContent = 'Could not update cart. Please refresh and try again.';
      setBusy(row, false);
    });
  }

  itemsWrap.addEventListener('click', function(e){
    var row = e.target.closest('.kj-cart-item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var qtyEl = row.querySelector('.kj-qty-val');
    var qty = parseInt(qtyEl.textContent, 10);

    if (e.target.closest('.kj-qty-plus')) {
      changeLine(key, qty + 1, row);
    } else if (e.target.closest('.kj-qty-minus')) {
      changeLine(key, Math.max(0, qty - 1), row);
    } else if (e.target.closest('.kj-cart-remove')) {
      changeLine(key, 0, row);
    }
  });
})();

// Scroll-reveal for premium entrance animations on cards
(function() {
  var els = document.querySelectorAll('.an-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('an-in-view'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('an-in-view');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function(el, i) {
    el.style.transitionDelay = (i % 6) * 70 + 'ms';
    io.observe(el);
  });
})();

// WhatsApp greeting bubble - shows after a short delay, dismissible
(function() {
  var greeting = document.getElementById('waGreeting');
  var closeBtn = document.getElementById('waGreetingClose');
  if (!greeting) return;

  var dismissed = false;
  try { dismissed = sessionStorage.getItem('anWaGreetingDismissed') === '1'; } catch(e) {}
  if (dismissed) return;

  setTimeout(function() {
    greeting.classList.add('wa-show');
  }, 2200);

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      greeting.classList.remove('wa-show');
      try { sessionStorage.setItem('anWaGreetingDismissed', '1'); } catch(e) {}
    });
  }
})();
